// extracted by mini-css-extract-plugin
export var card = "_ji-5";
export var cardSelected = "_ji-4";
export var image = "_ji-3";
export var modal = "_ji-0";
export var modalContent = "_ji-1";
export var table = "_ji-2";